var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("v-file-input", {
                key: _vm.inputKey,
                ref: "fileSelector",
                attrs: {
                  dense: "",
                  type: "file",
                  accept: "video/*",
                  label: _vm.formatParameter.description,
                  rules: [_vm.required],
                  showSize: true,
                  placeholder: _vm.inputPlaceholder,
                  clearable: false
                },
                model: {
                  value: _vm.file,
                  callback: function($$v) {
                    _vm.file = $$v
                  },
                  expression: "file"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { staticClass: "d-flex", attrs: { cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    disabled: !_vm.isDeleteAvailable,
                    color: "white",
                    title: "Reset to default format value"
                  },
                  on: { click: _vm.onFileSelectorClear }
                },
                [_c("v-icon", [_vm._v("mdi-undo")])],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: {
                    icon: "",
                    disabled: !_vm.isPreviewAvailable,
                    color: "white",
                    title: "Show preview"
                  },
                  on: { click: _vm.previewVideo }
                },
                [_c("v-icon", [_vm._v("mdi-video")])],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "v-label v-label--active theme--dark",
          staticStyle: { "margin-top": "-15px" }
        },
        [_vm._v("\n    " + _vm._s(_vm.lblShowStatus) + "\n  ")]
      ),
      _vm._v(" "),
      _vm.filePreview
        ? _c("popupDialog", { attrs: { dialogModel: _vm.filePreview } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }